import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CanActivate, ActivatedRouteSnapshot, NavigationCancel, NavigationEnd, NavigationError, Router, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/observable/of';

import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';
import { AUTH_ACCESS } from './auth.access';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  loader = true;
  loaderChange = new Subject<boolean>();

  enterprises;
  is_distributor;
  rights: {
    role: string;
    type: string;
  };
  session: {
    id: number;
    email: string;
    firstname: string;
    lastname: string;
    picture: string;
    selected_enterprise: number;
  };

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private router: Router
  ) {
    this.loaderChange.subscribe((value) => {
      this.loader = value;
    });

    // Filet de sécurité : reset le loader quand toute navigation se termine
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        if (this.loader) {
          this.loaderChange.next(false);
        }
      }
    });
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (state.url.indexOf('/auth/action-plans') !== -1 || state.url.indexOf('/auth/enterprise') !== -1) {
      this.loaderChange.next(false);
      return true;
    }
    else if (state.url === '/auth/login' || state.url.indexOf('/auth/forgot-password') !== -1) {
      this.loaderChange.next(false);
      return true;
    } else {
      this.loaderChange.next(true);
      return this.http.get(environment.API_PATH + 'auth/session', {withCredentials: true}).timeout(15000).map(response => {
        if (response['success']) {
          this.enterprises = response['enterprises'];
          this.is_distributor = response['is_distributor'];
          this.rights = response['rights'];
          this.session = response['session'];
          this.loaderChange.next(false);
          return true;
        } else {
          this.loaderChange.next(false);
          this.router.navigate(['/auth/login']).then(() => {});
          return false;
        }
      }).catch(() => {
        this.loaderChange.next(false);
        this.router.navigate(['/auth/login']).then(() => {});
        return Observable.of(false);
      });
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.hasAccess(route.data['action']);
  }

  hasAccess(action: string): boolean {
    // TODO: remove this line !
    // if (this.rights && this.rights.role === 'ADMIN' && this.rights.type === 'ADMIN' && window.location.href.indexOf('localhost') !== -1) {return true}
    if (action === 'dashboard' && (!this.rights || this.rights.role !== 'GUEST')) {return true}
    // TODO END

    if (!this.rights || !this.rights.role || !this.rights.type) {
      return false;
    }

    return (
      action
      && action in AUTH_ACCESS
      && this.rights.role in AUTH_ACCESS[action]
      && AUTH_ACCESS[action][this.rights.role].indexOf(this.rights.type) !== -1
    );
  }

  getCurrentEnterpriseId() {
    return this.session['selected_enterprise'];
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/auth/auth.guard.ts